<template>
  <div class="m-content-header">
    <div>
      <header>
        <div class="back-wrapper header-box" @click="back()">
          <img src="../assets/images/c-arrow_left.png" alt="" style="width: 1.5rem;height: 1.5rem;">
        </div>
        <div class="center-wrapper header-box">
          <p>{{titleZh}}</p>
        </div>
        <div v-if="showRight && !thumbnailFullFlag" class="right-body">
          <img src="../assets/images/share.png" @click="shareAction">
        </div>
      </header>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'LiteAppHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    showRight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    titleZh () {
      if (this.title.length > 8) {
        return this.title.substr(0, 8) + '...'
      } else {
        return this.title
      }
    },
    ...mapGetters([
      'thumbnailFullFlag'
    ])
  },
  methods: {
    back () {
      document.addEventListener('deviceready', function () {
        window.cordova.exec(function (success) {
          console.log(success)
        }, function (error) {
          console.log(error)
        }, 'MideaCommon', 'exit', [])
      }, false)
    },
    shareAction () {
      this.$emit('shareAction')
    }
  }
}
</script>

<style scoped>
  .m-content-header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 3.0625rem;
    z-index: 10000;
  }
  @media screen and (min-width: 769px) {
    .m-content-header {
      width: 750px;
    }
  }
  header {
    position: relative;
    padding: .532rem .6rem;
    background-color: #ffffff;
    border-top-width: 0;
    border-right-width: 0;
    border-left-width: .0625rem;
    border-color: #d9d9d9;
    border-style: solid;
  }
  header .back-wrapper {
    width: 3.125rem;
    height: 1.9375rem;
    position: absolute;
    left: 0;
    top: .75rem;
    text-align: center;
    line-height: 1.9375rem;
  }
  header .center-wrapper {
    width: 100%;
    height: 1.9375rem;
    padding: .125rem 3.5rem 0 3.5rem;
    box-sizing: border-box;
    text-align: center;
  }
  header .center-wrapper p {
    text-align: center;
    margin-block-start: 0;
    margin-block-end: 0;
    line-height: 1.625rem;
    word-wrap: break-word;
    font-size: 1.1875rem;
    font-weight: 600;
  }
  header .right-wrapper {
    width: 6.0625rem;
    height: 2rem;
    position: absolute;
    right: 0;
    top: .5rem;
    padding: .3rem 0 0 2.4375rem;
  }
  header .right-wrapper a {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    text-decoration: none;
    color: #1b9af4;
  }
  main>div {
    overflow-y: hidden;
    padding: .6rem;
    height: calc(100vh - 3.5rem);
    background-color: #fff;
  }
  main>div>textarea{
    font-family: sans-serif;
    margin-top: .65625rem;
    color: #333;
    background-color: transparent;
    outline: 0;
    border: none;
    font-size: 1rem;
    resize: none;
    width: 100%;
    box-sizing: border-box;
  }
  .rotate180 {
    transform: rotate(180deg);
    transition:transform .1s linear;
  }
  .rotate0 {
    transform: rotate(0deg);
    transition:transform .1s linear;
  }
  .relative {
    position: relative;
  }
  .absolute {
    position: absolute;
  }
  .choose-id-box {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.5);
  }
  .choose-id-box>ul {
    display: flex;
    justify-content: space-around;
    width: 100%;
    background-color: #fff;
  }
  .choose-id-box>ul>li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 1rem;
  }
  .choose-id-box>ul>li>img {
    width: 2rem;
    height: 2rem;
  }
  .choose-id-box>ul>li>a {
    font-size: .875rem;
    color:#333;
  }
  .com-input {
    width: 100%;
    height: 2rem;
    margin-top: -.0625rem;
    border-radius: .3125rem;
    text-align: center;
    line-height: 1rem;
    border: .0625rem solid #f8f8f8;
    outline: 0;
  }
  .slide-fade-enter-active {
    transition: all .3s linear;
  }
  .slide-fade-leave-active {
    transition: all .3s linear;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(-.625rem);
    opacity: 0;
  }
  .right-body{
    width: 3.125rem;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    text-align: center;
    line-height: 1.9375rem;
    display: flex;
  }
  .right-body>img{
    margin: auto;
    width: 1.706667rem;
  }
</style>
